import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Seo from "@/components/Seo";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import RoomsPreviewSection from "./components/RoomsPreviewSection";
import OnsenSection from "./components/OnsenSection";
import PricingSection from "./components/PricingSection";
import AccessSection from "./components/AccessSection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Seo />
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <section id="rooms" aria-label="お部屋のご案内">
          <RoomsPreviewSection />
        </section>
        <OnsenSection />
        <PricingSection />
        <AccessSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}